import { Injectable } from "@angular/core";
import { CclList } from "certain-common-library";

@Injectable()
export class ListService {
    items: CclList;
}